import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  RouterModule,
  Routes
} from '@angular/router';



import { SignonRoutingModule } from './signon-routing.module';
import { SignonLayoutComponent } from './signon-layout.component';
import { SignOnFormComponent } from './sign-on-form/sign-on-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PrimaryBannerComponent } from './primary-banner/primary-banner.component';
import { DisclosureBannerComponent } from './disclosure-banner/disclosure-banner.component';
import { SecondaryBannerComponent } from './secondary-banner/secondary-banner.component';
import { FlexBannerComponent } from './flex-banner/flex-banner.component';
import { FlexSeoComponent } from './flex-seo/flex-seo.component';
import { SignOnHeaderComponent } from './sign-on-header/sign-on-header.component';
import { CrsUnsubscriberComponent } from './crs-unsubscriber.component';

//TODO
import { SharedModule } from '../shared/shared.module';
import {
  NgxWebstorageModule,
  LocalStorageService,
  SessionStorageService,
} from 'ngx-webstorage';
import { WINDOW_PROVIDER } from '@citi-gcg-173875/citi-utils';

//import { PopupSiteUiKitComponent } from '../shared/popup-content/site/popup-site-ui-kit/popup-site-ui-kit.component';
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    SignonRoutingModule,
    NgxWebstorageModule
  ],
  declarations: [
    SignonLayoutComponent,
    SignOnFormComponent,
    PrimaryBannerComponent,
    DisclosureBannerComponent,
    SecondaryBannerComponent,
    FlexBannerComponent,
    FlexSeoComponent,
    SignOnHeaderComponent,
    CrsUnsubscriberComponent
    //PopupSiteUiKitComponent
  ],
  providers: [LocalStorageService, SessionStorageService, WINDOW_PROVIDER],
  exports: [
    SignOnFormComponent,
    PrimaryBannerComponent,
    DisclosureBannerComponent,
    SecondaryBannerComponent,
    FlexBannerComponent,
    FlexSeoComponent,
    SignOnHeaderComponent
  ]
})
export class SignonModule { }
